import React, { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import { Button, TextField } from "@mui/material";
import ERPOutStandingBills from "./ERPOutStandingBills";
import ERPQuotation from "./quote/ERPQuotation";
import HMSPaymentRequest from "./hmspaymentrequest/HMSPaymentRequest";
import {
  All_Component_Name,
  COMPONENT_TYPE_COMPONENT,
  COMPONENT_TYPE_NULL,
  ORG_DETAILS,
} from "../../shared/constants";
import ProtectedComponent from "../common/ProtectedComponent";
import {
  ERP_INVOICE_QUOTATION_TYPE,
  ERP_LABEL_ADVANCE_REQUEST,
  ERP_LABEL_INVOICE_QUOTATION,
  ERP_OUTSTANDING_BILL_LISTING,
  ERP_PAYMENT_MODE,
  ERP_TABLE_NEW_QUOTATION_INVOICE_ITEMS,
  HMS_ERP_BILL_CLEAR_ADVANCE_TYPE,
  HMS_ERPPAYMENT_PAYMENT_TYPE,
  HMS_PAYMENT_REUQEST_TYPE,
  PAGE_MODE,
} from "../../core/constants/erpConstants";
import ERPPayment from "./ERPPayment";
import { helperServices } from "../../shared/helper";
import { patientActions } from "../../core/actions";
import { useDispatch } from "react-redux";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { isValid, format } from "date-fns";
import Filter from "./Filter";
import ERPVisitFinancialSummary from "./erpVisitFinancialSummary";
import { useLocation, useHistory } from "react-router-dom";
import { DataContext } from "./ERPBilling";
import ErrorScreen from "../../shared/helper/ErrorScreen";
import ERPProductSearch from "./ERPProductSearch";
import { useOrganization } from "../../configurations/OrganizationContext";
import { successDispatch } from "./ERPActions/erpActions";
import { isFullInvoiceNumber } from "./FinancialCardUpdate";

export default function AllCustomerInvoicePaymentRequest() {

  const org = useOrganization();
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [showOutstandingBill, setShowOutstandingBill] = useState(false);
  const [billClearAmtOverride, setBillClearAmtOverride] = useState();
  const [invoicePaymentDetails, setInvoicePaymentDetails] = useState();
  const [paymentInitialisedMode, setPaymentInitialisedMode] = useState();
  const [showPayment, setShowPayment] = useState(false);
  const [reload, setReload] = useState(false);

  const [outstandingBillClearType, setOutstandingBillClearType] = useState(
    HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_All_PATIENT_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR
  );
  const [paymentType, setPaymentType] = useState(ERP_PAYMENT_MODE.CASH);

  const [searchText, setSearchText] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarMode, setCalendarMode] = useState("single");
  const [selectedDate, setSelectedDate] = useState(null);
  const today = new Date();
  const [dateRange, setDateRange] = useState({
    start: today,
    end: today,
  });
  const [dateError, setDateError] = useState("");
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [productSelected, setProductSelected] = useState();
  const [tags, setTags] = useState([]);
  const [errorMessages, setErrorMessages] = useState("");

  const [patientId, setpatientId] = useState(null);
  const [visitId, setVisitId] = useState(null);


  const updateGridDataFromProdSearch = (prod) => {
    console.log("selected product : ", prod);
    // console.log("newInvoiceItems : ", newInvoiceItems);
    // const currentItems = newInvoiceItems || []; // Ensure we have an array
    const currentItems = []; // Ensure we have an array

    // Create new row object
    const newRow = {
      date: Date.now(),
      slNo: currentItems.length + 1,
      serviceName: prod.typePackage ? prod.name : prod.packageServiceName,
      description: prod.typePackage ? prod.name : prod.packageServiceName,
      originalPrice: prod.typePackage ? prod.sellPriceTax : prod.sellPricetax,
      updatedOriginalPrice: prod.typePackage
        ? prod.sellPriceTax
        : prod.sellPricetax,
      charges: prod.priceDiscountIncTax,
      discountCharges: prod.sellPricetax - prod.priceDiscountIncTax,
      originalDiscountCharges: prod.priceDiscountIncTax,
      quantity: 1,
      price: prod.priceDiscountIncTax,
      type: ERP_INVOICE_QUOTATION_TYPE.NEW_INVOICE_QUOTATION,
      typePackage: prod.typePackage,
      productDetail: prod,
      prodId: prod?.reference,
      soId: null,
      isKPCreditDiscountApplicable: !(
        prod.isDoctor === "true" && prod.gvId > 0 && org.orgCode === ORG_DETAILS.MNH_DETAILS.orgCode
      ),
      action: "delete",
      value: value,
      billable: prod.billable,
      serviceList: [],
    };

    // If it's a package, also create rows for each service in the serviceList
    if (prod.typePackage && Array.isArray(prod.serviceList)) {
      prod.serviceList.forEach((service, index) => {
        const serviceRow = {
          date: Date.now(),
          slNo: currentItems.length + 1 + index, // continue serial number
          serviceName: service.packageServiceName,
          description: service.packageServiceName,
          originalPrice: service.sellPricetax,
          updatedOriginalPrice: service.sellPricetax,
          charges: service.priceDiscountIncTax,
          originalDiscountCharges: service.priceDiscountIncTax,
          quantity: 1,
          price: service.priceDiscountIncTax,
          type: ERP_INVOICE_QUOTATION_TYPE.NEW_INVOICE_QUOTATION,
          typePackage: false, // child rows are not packages themselves
          productDetail: service,
          prodId: service?.reference,
          isKPCreditDiscountApplicable: !(service.isDoctor === "true" && service.gvId > 0 && org.orgCode === ORG_DETAILS.MNH_DETAILS.orgCode),
          soId: null,
          action: "delete",
          value: value,
          billable: service.billable,
        };
        newRow.serviceList.push(serviceRow);
        // newRows.push(serviceRow);
      });
    }
    setProductSelected(newRow);
    console.log("newRow to be added: ", newRow);
    // Always dispatch with the complete new array
    const updatedItems = [...currentItems, newRow];
    console.log("updatedItems to be dispatched: ", updatedItems);
    dispatch(successDispatch(ERP_TABLE_NEW_QUOTATION_INVOICE_ITEMS, updatedItems));
  };

  const showMessageStrip = (message, msgtype) => {
    var ServerResVal = ServerRes;
    if (msgtype == "success") {
      ServerResVal.success = message;
    } else {
      ServerResVal.error = message;
    }
    setServerRes({ ...ServerResVal });
    setTimeout(() => {
      closeAlert();
    }, 2000);
  };

  const closeAlert = () => {
    setServerRes({ success: "", error: "" });
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const history = useHistory();
  const location = useLocation();

  const getPatientProfile = (patId) => {
    return dispatch(
      patientActions.getPatientProfile(patId, (resCb) => {
        if (resCb) {
          console.log("patientprofile", resCb);
          setErrorMessages(
            Array.isArray(resCb?.errorMessages) ? resCb.errorMessages[0] : ""
          );
          return true;
        }
      })
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const settleOutstandingBills = async (a, b) => {
    console.log("settleOutstandingBills: ", a, b);
    const invDetail = { invoiceDetail: a.rowData.rowInvoiceData };
    await getPatientProfile(invDetail.invoiceDetail.patientERPObj.id);
    setPaymentInitialisedMode(
      HMS_ERPPAYMENT_PAYMENT_TYPE.INVOICE_PAYMENT_FOR_SELECTED_INVOICES
    );
    invDetail.invoiceDetail["invoiceId"] = invDetail.invoiceDetail.invoiceNo;
    invDetail.invoiceDetail["totalInvoiceAmount"] =
      invDetail.invoiceDetail.billTotalAmount;
    invDetail["type"] = ERP_OUTSTANDING_BILL_LISTING;
    invDetail["invoiceId"] = invDetail.invoiceDetail.invoiceNo;
    invDetail["locationId"] = invDetail?.invoiceDetail?.locationId;
    setInvoicePaymentDetails(invDetail);
    setBillClearAmtOverride(invDetail.invoiceDetail.outstandingBalance);
    setShowPayment(true);
  };

  const handlePaymentRequestApproval = async (paymentRequest) => {
    console.log("handlePaymentRequestApproval: ", paymentRequest);
    await getPatientProfile(paymentRequest.patientId);
    const amount = Number(paymentRequest?.requestedAmount || 0);
    setBillClearAmtOverride(isNaN(amount) ? 0 : amount);
    setInvoicePaymentDetails({ ...paymentRequest });
    if (HMS_PAYMENT_REUQEST_TYPE.ADVANCE_REQUEST === paymentRequest.type) {
      setPaymentInitialisedMode(
        HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY
      );
    } else if (
      HMS_PAYMENT_REUQEST_TYPE.REFUND_REQUEST === paymentRequest.type
    ) {
      setPaymentInitialisedMode(
        HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_REFUND_PAYMENT_ONLY
      );
    }
    setShowOutstandingBill(false);
    setShowPayment(true);
  };

  const handleClearProps = (data) => {
    console.log("All cust inv paymt req:Handle clear props: ", data);
    setProductSelected("");
    setShowPayment(false);
    setBillClearAmtOverride(0);
    setInvoicePaymentDetails("");
  };

  const showPaymentPage = (data) => {
    console.log("showPaymentPage: ", data);
    setPaymentInitialisedMode("");
    setBillClearAmtOverride(undefined);
    setInvoicePaymentDetails("");
    setShowPayment(!showPayment);
    setShowOutstandingBill(false);
    if (!showPayment) {
      setReload(!reload);
    }
  };

  // Calendar Handlers
  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const clearCalendarSelection = () => {
    setSelectedDate(null);
    // setDateRange({ start: today, end: today });
    setTags((prev) => prev.filter((t) => t.type !== "date"));
    handleDateRange();
    setDateError("");
  };

  const handleCalendarChange = (value) => {
    if (Array.isArray(value)) {
      const [start, end] = value;
      if (!isValid(start) || !isValid(end)) return;
      const diffInMs = end - start;
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
      if (diffInDays > 31) {
        setDateError("Date range cannot exceed 31 days.");
        return;
      }
      setDateError("");
      setDateRange({ start, end });
      setSelectedDate(null);
      setShowCalendar(false);
      const startStr = format(start, "yyyy-MM-dd");
      const endStr = format(end, "yyyy-MM-dd");
      const displayRange = `${format(start, "dd/MM/yyyy")} – ${format(
        end,
        "dd/MM/yyyy"
      )}`;
      const dateTag = {
        type: "date",
        from: startStr,
        to: endStr,
        display: displayRange,
      };
      setTags((prev) => [...prev.filter((t) => t.type !== "date"), dateTag]);
      return;
    }
    if (!isValid(value)) return;
    if (calendarMode === "single") {
      setSelectedDate(value);
      setDateRange({ start: value, end: value }); // keep Date object
      setShowCalendar(false);

      const formattedApi = format(value, "yyyy-MM-dd");
      const formattedDisplay = format(value, "dd/MM/yyyy");

      const dateTag = {
        type: "date",
        from: formattedApi,
        to: formattedApi,
        display: formattedDisplay,
      };

      setTags((prev) => [...prev.filter((t) => t.type !== "date"), dateTag]);
    } else {
      setDateRange({ start: value, end: null });
      setSelectedDate(null);
    }
  };
  const intervalRef = useRef(null);
  useEffect(() => {
    const searchFromUrl = query.get("search") || "";
    const tagsFromUrl = query.get("tags") ? JSON.parse(query.get("tags")) : [];
    const start = query.get("startDate");
    const end = query.get("endDate");
    const loc = query.get("location") ? JSON.parse(query.get("location")) : [];
    const tabVal = query.get("tab") ? Number(query.get("tab")) : 0;

    // Restore ALL filters
    setSearchText(searchFromUrl);
    setTags(tagsFromUrl);
    setSelectedLocation(loc);
    setValue(tabVal);

    const hasInvoiceSearch = tagsFromUrl.some(
      (tag) =>
        tag?.type === "text" && isFullInvoiceNumber(tag?.value)
    );

    if (start && end) {
      setDateRange({
        start: new Date(start),
        end: new Date(end),
      });
    } else if (hasInvoiceSearch) {
      setDateRange({ start: null, end: null });
    } else {
      handleDateRange(); // default 30 days
    }
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setReload((prev) => !prev);
    }, 180000);

    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    updateUrlParams();
  }, [searchText, tags, dateRange, selectedLocation, value]);

  const handleDateRange = () => {
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setDate(today.getDate() - 30);
    const start = oneMonthAgo;
    const end = today;
    const startStr = format(start, "yyyy-MM-dd");
    const endStr = format(end, "yyyy-MM-dd");

    const displayRange = `${format(start, "dd/MM/yyyy")} – ${format(
      end,
      "dd/MM/yyyy"
    )}`;

    setDateRange({ start, end });

    setTags((prev) => [
      ...prev.filter((t) => t.type !== "date"),
      {
        type: "date",
        from: startStr,
        to: endStr,
        display: displayRange,
      },
    ]);

    // 3. Trigger search API if needed
    setReload((prev) => !prev);
    // handleCalendarChange("")
  };

  const updateUrlParams = () => {
    const params = new URLSearchParams();

    params.set("search", searchText || "");
    params.set("tags", JSON.stringify(tags));
    if (dateRange.start) {
      params.set("startDate", format(dateRange.start, "yyyy-MM-dd"));
    }
    if (dateRange.end) {
      params.set("endDate", format(dateRange.end, "yyyy-MM-dd"));
    }
    params.set("location", JSON.stringify(selectedLocation));
    params.set("tab", value);

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  const apiDateFrom = dateRange.start
    ? format(dateRange.start, "yyyy-MM-dd")
    : "";

  const apiDateTo = dateRange.end ? format(dateRange.end, "yyyy-MM-dd") : "";

  // Calculate display text for the date range
  const dateDisplayText =
    calendarMode === "single"
      ? selectedDate
        ? format(selectedDate, "dd/MM/yyyy")
        : ""
      : dateRange.start && dateRange.end
      ? `${format(dateRange.start, "dd/MM/yyyy")} – ${format(
          dateRange.end,
          "dd/MM/yyyy"
        )}`
      : "";

  if (showPayment && errorMessages) {
    return <ErrorScreen message={errorMessages} />; // return JSX
  }
  if (
    showPayment &&
    helperServices.CheckAccessLevel(All_Component_Name.AdvancePayment)
  ) {
    return (
      <div className="ms-2">
        <ProtectedComponent
          componentName={All_Component_Name.AdvancePayment}
          component={ERPPayment}
          paymentTowards={invoicePaymentDetails}
          paymentInitialisedMode={paymentInitialisedMode}
          billClearAmt={
            billClearAmtOverride !== undefined ? billClearAmtOverride : 0
          }
          clearOutstandingBillType={
            showOutstandingBill
              ? HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR
              : HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_ADVANCE_AMOUNT_TYPE_ADVANCE_PAYMENT
          }
          closePaymentPage={showPaymentPage}
          serverResposnes={showMessageStrip}
        />
      </div>
    );
  }

  const handleSelectedLocation = (locationDetail) => {
    console.log("handleSelectedLocation ERPBilling: ", locationDetail);
    setSelectedLocation(locationDetail);
  };

  const handleClearInvoiceStart = (paymentDetail) => {
    console.log("handleClearInvoiceStart: ", paymentDetail);
    // This was commented out in the original code. Uncomment if needed.
    // try {
    //   const amount = Number(paymentDetail?.amount || 0);
    //   setBillClearAmtOverride(isNaN(amount) ? 0 : amount);
    //   paymentDetail.rowData["netInvoiceClearAmt"] = amount;
    //   setInvoicePaymentDetails({ ...paymentDetail.rowData });
    //   setProductSelected("");
    //   setPaymentInitialisedMode(
    //     HMS_ERPPAYMENT_PAYMENT_TYPE.INVOICE_PAYMENT_FOR_SELECTED_INVOICES
    //   );
    //   setShowOutstandingBill(false);
    //   setShowPayment(true);
    // } catch (e) {
    //   console.error("handleClearInvoiceStart error:", e);
    // }
  };

  const clearTagsValue = (tag) => {
    const updated = tags.filter((t) => t !== tag);
    setTags(updated);

    if (updated.length > 0) {
      if (tag.type === "date") {
        clearCalendarSelection();
      }
    } else {
      setSearchText("");
      clearCalendarSelection();
    }
  };

  const handleKeyChange = (e) => {
    if (e.key !== "Enter") return;

    const enteredValue = searchText.trim();
    if (!enteredValue) return;

    const invoiceSearch = isFullInvoiceNumber(enteredValue);
    const textTag = {
      type: "text",
      value: enteredValue,
    };
    const otherTags = tags.filter(
      (tag) =>
        tag.type !== "text" && (!invoiceSearch || tag.type !== "date")
    );

    setTags([...otherTags, textTag]);

    if (invoiceSearch) {
      setSelectedDate(null);
      setDateRange({ start: null, end: null });
      setDateError("");
      setShowCalendar(false);
    }

    setSearchText("");
  };

  // const handleNavigateToBilling = (row) => {
  //   const currentUrl = window.location.href;
  //   window.location.href = `/billing/${row.patientId}/${row.visitId}?returnTo=${encodeURIComponent(currentUrl)}`;
  // };

  // const handleNavigateToBilling = ({ patientId, visitId }) => {
  //   const currentUrl = window.location.href;

  //   window.location.href =
  //     `/billing/${patientId}/${visitId}?returnTo=${encodeURIComponent(currentUrl)}`;
  // };

  const handleNavigateToBilling = ({ patientId, visitId }) => {
    // Get current URL for return
    const currentUrl = window.location.href;

    // Prepare URL params
    const params = new URLSearchParams();
    params.set("loc", selectedLocation); // your selected location
    params.set("returnTo", encodeURIComponent(currentUrl)); // returnTo for coming back

    // Navigate
    window.location.href = `/billing/${patientId}/${visitId}?${params.toString()}`;
  };

  return (
    <div className="mt-2 mb-2">
      {errorMessages ? (
        <ErrorScreen message={errorMessages} />
      ) : (
        <>
          {/* Search + Calendar + Filter */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start", // ⭐ keeps right side from dropping
              width: "100%",
              marginBottom: 3,
              marginLeft: 2,
              marginRight: 2,
              gap: 2,
            }}
          >
            {/* LEFT — SEARCH + TAGS */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                position: "relative", // ⭐ IMPORTANT for absolute tags
                paddingBottom: "35px", // space for tags below
              }}
              className="m-3"
            >
              {/* TextField */}
              <TextField
                id="global-search"
                placeholder="Search by Patient Name / MAIN / Invoice Number..."
                value={searchText}
                type="search"
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                onKeyDown={(e) => {
                  handleKeyChange(e);
                }}
                InputProps={{
                  style: { paddingLeft: "15px", height: "35px" },
                }}
                sx={{
                  width: "100%",
                  minWidth: "200px",
                }}
              />

              {/* TAGS BELOW TEXTFIELD */}
              {tags.length > 0 && (
                <div
                  style={{
                    position: "absolute", // ⭐ prevents layout shift
                    top: "45px", // place below TextField
                    left: "0",
                    width: "100%",
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                    paddingTop: "5px",
                  }}
                >
                  {tags.map((tag, i) => (
                    <div
                      key={i}
                      style={{
                        padding: "5px 10px",
                        background: "#e0e0e0",
                        borderRadius: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ marginRight: "8px", fontSize: "12px" }}>
                        {tag.type === "text" ? tag.value : tag.display}
                      </span>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                        onClick={() => clearTagsValue(tag)}
                      >
                        ✕
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </Box>

            {/* RIGHT — FILTER + CALENDAR */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                flexShrink: 0,
                position: "relative",
                marginTop: "10px",
              }}
            >
              {/* Calendar Icon */}
              <i
                className="material-icons"
                onClick={toggleCalendar}
                style={{
                  cursor: "pointer",
                  fontSize: "22px",
                  padding: "6px",
                }}
              >
                calendar_month
              </i>

              {/* Filter */}
              <div style={{ marginRight: "50px" }}>
                <Filter
                  selectedLocation={handleSelectedLocation}
                  currentLocation={selectedLocation}
                />
              </div>

              {/* Calendar Popup */}
              {showCalendar && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "45px",
                    right: "0px",
                    background: "white",
                    padding: "10px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                    borderRadius: "6px",
                    zIndex: 1000,
                  }}
                >
                  <div className="d-flex justify-content-between mb-2">
                    <button
                      type="button"
                      className={`btn btn-sm ${
                        calendarMode === "single"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => setCalendarMode("single")}
                      style={{ fontSize: "0.75rem" }}
                    >
                      Single Date
                    </button>

                    <button
                      type="button"
                      className={`btn btn-sm ${
                        calendarMode === "range"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => setCalendarMode("range")}
                      style={{ fontSize: "0.75rem" }}
                    >
                      Date Range
                    </button>

                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={clearCalendarSelection}
                      style={{ fontSize: "0.75rem" }}
                    >
                      Clear
                    </button>

                    <button
                      type="button"
                      onClick={() => setShowCalendar(false)}
                      className="btn btn-sm btn-light border-0"
                      title="Close calendar"
                    >
                      <i
                        className="material-icons"
                        style={{ fontSize: "1.2rem" }}
                      >
                        close
                      </i>
                    </button>
                  </div>

                  <Calendar
                    onChange={handleCalendarChange}
                    value={
                      calendarMode === "single"
                        ? selectedDate
                        : dateRange.start && dateRange.end
                        ? [dateRange.start, dateRange.end]
                        : dateRange.start
                    }
                    selectRange={calendarMode === "range"}
                    maxDate={new Date()}
                  />
                  {dateError && (
                    <div className="mt-2 text-center">
                      <small className="text-danger">{dateError}</small>
                    </div>
                  )}
                </Box>
              )}
            </Box>
          </Box>

          {/* Tabs */}
          <div className="d-flex justify-content-between align-items-baseline mx-3 px-3 my-2">
            <h5 className="page-title mb-0">
              Customer Invoice & Payment Request
            </h5>
            <div className="d-flex justify-content-end flex-wrap">
              <Button
                variant={value === 0 ? "contained" : "outlined"}
                color="primary"
                className="mb-1 mr-2 button-patient"
                onClick={(e) => handleChange(e, 0)}
                style={{ textTransform: "none" }}
              >
                All
              </Button>
              <Button
                variant={value === 1 ? "contained" : "outlined"}
                color="primary"
                className="mb-1 mr-2 button-patient"
                onClick={(e) => handleChange(e, 1)}
                style={{ textTransform: "none" }}
              >
                Outstanding Bills
              </Button>
              <Button
                variant={value === 2 ? "contained" : "outlined"}
                color="primary"
                className="mb-1 mr-2 button-patient"
                onClick={(e) => handleChange(e, 2)}
                style={{ textTransform: "none" }}
              >
                {ERP_LABEL_ADVANCE_REQUEST}
              </Button>
              <Button
                variant={value === 3 ? "contained" : "outlined"}
                color="primary"
                className="mb-1 mr-2 button-patient"
                onClick={(e) => handleChange(e, 3)}
                style={{ textTransform: "none" }}
              >
                {ERP_LABEL_INVOICE_QUOTATION}
              </Button>
            </div>
          </div>

          {/* Tab Content */}
          <div className="px-3">
            <div className="preview p-3">
              <Box sx={{ width: "100%" }}>
                <DataContext.Provider
                  value={{
                    prodcutSelected: productSelected,
                    setProductSelected,
                  }}
                >
                  {value === 0 && (
                    <ProtectedComponent
                      key={`${apiDateFrom}-${apiDateTo}-${
                        selectedLocation.length
                      }-${JSON.stringify(tags)}-${reload}`}
                      componentName={All_Component_Name.FinancialSummary}
                      component={ERPVisitFinancialSummary}
                      pageType={COMPONENT_TYPE_COMPONENT}
                      pageMode={PAGE_MODE.ALL_INVOICELIST}
                      dateRange={{ start: apiDateFrom, end: apiDateTo }}
                      selectedLocationDetails={selectedLocation}
                      onClearInvoiceStart={handleClearInvoiceStart}
                      searchText={searchText}
                      searchtags={tags}
                      reload={reload}
                      onRowClick={handleNavigateToBilling}
                    />
                  )}

                  {value === 1 && (
                    <ERPOutStandingBills
                      key={`${JSON.stringify(tags)}`}
                      billClearType={outstandingBillClearType}
                      pymtType={paymentType}
                      // searchQuery={searchText}
                      dateRange={{ start: apiDateFrom, end: apiDateTo }}
                      searchtags={tags}
                      pageMode={PAGE_MODE.ALL_INVOICELIST}
                      onClearInvoiceStart={settleOutstandingBills}
                      selectedLocation={selectedLocation}
                      onRowClick={handleNavigateToBilling}
                    />
                  )}

                  {value === 2 && (
                    <HMSPaymentRequest
                      key={`${JSON.stringify(tags)}`}
                      onPaymentRequestApproved={handlePaymentRequestApproval}
                      closeNewInvoice={handleChange}
                      // searchQuery={searchText}
                      dateRange={{ start: apiDateFrom, end: apiDateTo }}
                      reloadComponent={reload}
                      clearProps={handleClearProps}
                      serverResposnes={showMessageStrip}
                      searchtags={tags}
                      onRowClick={handleNavigateToBilling}
                    />
                  )}

                  {value === 3 && (
                    <div>
                        <ProtectedComponent
                          key={All_Component_Name.INVOICEQUOTATION}
                          componentName={All_Component_Name.INVOICEQUOTATION}
                          component={ERPQuotation}
                          pageType={COMPONENT_TYPE_NULL}
                          patientId={patientId?? null}
                          visitId={visitId?? null}
                          selectedLocationDetails={selectedLocation}
                          dateRange={{ start: apiDateFrom, end: apiDateTo }}
                          searchText={searchText}
                          searchtags={tags}
                          rowUpdate={productSelected}
                          onProductSelected={updateGridDataFromProdSearch}
                          closeNewInvoice={handleChange}
                          // invPaymentDetails={handleInvPaymentDetails}
                          clearProps={handleClearProps}
                          serverResposnes={showMessageStrip}
                          // searchInputRef={searchInputRef}
                          isKpCash={true}
                          reload={reload}
                        />
                      </div>
                  )}
                </DataContext.Provider>
              </Box>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
